import React from "react"
import { ListGroup } from "react-bootstrap"
import { ReportAPI } from "../../../lib/utils"
import ReportLinkItem from "../ReportLinkItem"

export default function FinancierReportLinks({ api }) {

  return (
    <ListGroup>

      <ReportLinkItem url='/reports/batch-performance' title='Batch Performance (Summary, Details)'
        disabled={ api === ReportAPI.BATCH_PERFORMANCE } />

      <ReportLinkItem url='/reports/bucket-performance' title='Bucket Performance (Summary, Details)'
        disabled={ api === ReportAPI.BUCKET_PERFORMANCE } />
    </ListGroup>
  )
}



// WEBPACK FOOTER //
// ./src/components/Reports/financiers/FinancierReportLinks.js